<div class="contact-page">
  <!-- Page Header -->
  <section class="page-header">
    <div class="container">
      <h1 class="page-title">Kontakt</h1>
      <p class="page-subtitle">Wir sind für Sie da - kontaktieren Sie uns!</p>
    </div>
  </section>

  <!-- Kontakt- & Notdienst-Banner -->
  <section
    class="contact-banner"
    *ngIf="contactInfo"
    [class.is-open]="isOpenNow"
    [class.is-closed]="!isOpenNow">
    <div class="container">
      <div class="banner-grid" [class.single]="!showEmergency">

        <!-- Regulärer Kontakt (Normaltarif) -->
        <div class="banner-card banner-card--regular">
          <div class="banner-card__icon">
            <i class="fas fa-phone-alt"></i>
          </div>
          <div class="banner-card__body">
            <span class="banner-status">
              <span class="dot" [class.dot--open]="isOpenNow" [class.dot--closed]="!isOpenNow"></span>
              {{ isOpenNow ? 'Jetzt geöffnet' : 'Aktuell geschlossen' }}
            </span>
            <h3>Anruf zum Normaltarif</h3>
            <p *ngIf="isOpenNow">
              Für Angebote, Termine und alle alltäglichen Anliegen sind wir jetzt
              für Sie da &ndash; ganz ohne Zuschlag.
            </p>
            <p *ngIf="!isOpenNow">
              {{ nextOpeningText }}. Für normale Anliegen rufen Sie uns bitte
              zu den Öffnungszeiten an &ndash; ohne Zuschlag.
            </p>
          </div>
          <a [href]="'tel:' + toTelHref(contactInfo.phone)" class="btn-call btn-call--primary">
            <i class="fas fa-phone"></i>
            {{ contactInfo.phone }}
          </a>
        </div>

        <!-- Notdienst (werktags 18–6 Uhr, am Wochenende durchgehend) -->
        <div class="banner-card banner-card--emergency" *ngIf="showEmergency">
          <div class="banner-card__icon">
            <i class="fas fa-exclamation-triangle"></i>
          </div>
          <div class="banner-card__body">
            <h3>24/7 Notdienst</h3>
            <p>
              Nur für echte Notfälle, die nicht warten können &ndash; etwa um einen
              Wasserrohrbruch oder Heizungsausfall zu beheben.
            </p>
          </div>
          <a [href]="'tel:' + toTelHref(contactInfo.emergencyPhone)" class="btn-call btn-call--emergency">
            <i class="fas fa-phone"></i>
            {{ contactInfo.emergencyPhone }}
          </a>
        </div>

      </div>
    </div>
  </section>

  <!-- Contact Content -->
  <section class="contact-content section">
    <div class="container">
      <div class="row g-5">
        <!-- Contact Information -->
        <div class="col-lg-6">
          <div class="contact-info h-100" *ngIf="contactInfo">
            <h3>Kontaktinformationen</h3>
            
            <!-- Address -->
            <div class="info-item">
              <div class="info-icon">
                <i class="fas fa-map-marker-alt"></i>
              </div>
              <div class="info-content">
                <h5>Adresse</h5>
                <p>
                  {{ contactInfo.address.street }}<br>
                  {{ contactInfo.address.zip }} {{ contactInfo.address.city }}
                </p>
              </div>
            </div>

            <!-- Phone -->
            <div class="info-item">
              <div class="info-icon">
                <i class="fas fa-phone"></i>
              </div>
              <div class="info-content">
                <h5>Telefon</h5>
                <p><a [href]="'tel:' + toTelHref(contactInfo.phone)">{{ contactInfo.phone }}</a></p>
              </div>
            </div>

            <!-- Email -->
            <div class="info-item">
              <div class="info-icon">
                <i class="fas fa-envelope"></i>
              </div>
              <div class="info-content">
                <h5>E-Mail</h5>
                <p><a href="mailto:{{ contactInfo.email }}">{{ contactInfo.email }}</a></p>
              </div>
            </div>

            <!-- Opening Hours -->
            <div class="info-item">
              <div class="info-icon">
                <i class="fas fa-clock"></i>
              </div>
              <div class="info-content">
                <h5>Öffnungszeiten</h5>
                <div class="opening-hours">
                  <div class="hours-item" *ngFor="let item of getOpeningHoursArray()" [class.today]="item.isToday">
                    <span class="day">{{ item.day }}:</span>
                    <span class="hours">{{ item.hours }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Emergency (werktags 18–6 Uhr, am Wochenende durchgehend) -->
            <div class="info-item emergency" *ngIf="showEmergency">
              <div class="info-icon">
                <i class="fas fa-exclamation-triangle"></i>
              </div>
              <div class="info-content">
                <h5>Notdienst</h5>
                <p>
                  24/7 erreichbar unter<br>
                  <a [href]="'tel:' + toTelHref(contactInfo.emergencyPhone)">{{ contactInfo.emergencyPhone }}</a><br>
                  <span class="note">Bitte nur im echten Notfall anrufen</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Emergency Service Component -->
        <div class="col-lg-6">
          <app-emergency-service class="h-100"></app-emergency-service>
        </div>
      </div>
    </div>
  </section>

  <!-- Map Section -->
  <section class="map-section">
  <div class="container">
    <h3 class="text-center mb-4">So finden Sie uns</h3>
    
    <!-- Einfache Google Maps ohne API Key -->
    <div class="map-container">
      <iframe 
        src="https://www.google.com/maps/embed?pb=!1m28!1m12!1m3!1d1215.3443905928702!2d13.382660007091406!3d52.46666354298265!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m13!3e2!4m5!1s0x47a84ffc663f147d%3A0xd34f017be1c2448e!2sAlt-Tempelhof%2C%2012099%20Berlin!3m2!1d52.4662365!2d13.3858403!4m5!1s0x47a84ffd73794c8d%3A0x28d7c14432bce456!2sBorussiastra%C3%9Fe%2062A%2C%2012103%20Berlin!3m2!1d52.46732!2d13.38206!5e0!3m2!1sde!2sde!4v1749078536324!5m2!1sde!2sde" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"
        width="100%" 
        height="400" 
        style="border:0; border-radius: 10px;" 
        allowfullscreen="" 
        loading="lazy" 
        referrerpolicy="no-referrer-when-downgrade">
      </iframe>
    </div>

    <!-- Adresse unter der Karte -->
    <div class="address-info text-center mt-4">
      <div class="row">
        <div class="col-md-6">
          <h5><i class="fas fa-map-marker-alt"></i> Unser Standort</h5>
          <p *ngIf="contactInfo">
            <strong>Mitra Sanitär GmbH</strong><br>
            {{ contactInfo.address.street }}<br>
            {{ contactInfo.address.zip }} {{ contactInfo.address.city }}
          </p>
        </div>
        <div class="col-md-6">
          <h5><i class="fas fa-route"></i> Anfahrt</h5>
          <a href="https://www.google.com/maps/dir/Alt-Tempelhof,+12099+Berlin/Borussiastra%C3%9Fe+62A,+12103+Berlin/@52.4666635,13.38266,18z/data=!3m1!4b1!4m14!4m13!1m5!1m1!1s0x47a84ffc663f147d:0xd34f017be1c2448e!2m2!1d13.3858403!2d52.4662365!1m5!1m1!1s0x47a84ffd73794c8d:0x28d7c14432bce456!2m2!1d13.38206!2d52.46732!3e2?entry=ttu&g_ep=EgoyMDI1MDYwMi4wIKXMDSoASAFQAw%3D%3D" 
             target="_blank" 
             class="btn btn-primary">
            <i class="fas fa-directions"></i> Route planen
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
</div>